import { Component, ContentChild, Input, TemplateRef } from '@angular/core';
import { DomainLookup } from 'src/app/model/interfaces/DomainLookup.interface';

@Component({
    selector: 'app-domain-navigation',
    templateUrl: './domain-navigation.component.html',
    styleUrls: ['./domain-navigation.component.scss']
})
export class DomainNavigationComponent {
    @Input() domains?: DomainLookup[];

    @ContentChild(TemplateRef) itemTemplate: TemplateRef<any> | null = null;

    constructor() { }
}
